import HttpClient from "./index"
import ApiRoutes, { baseUrl } from "../config/endpoints"

export default class MetricAPI extends HttpClient {
  constructor() {
    super(baseUrl)
    this._initializeRequestInterceptor()
  }

  // Metric

  metricTabs = ApiRoutes.Metric.MetricTabs
  metricGroups = ApiRoutes.Metric.MetricGroups
  metricGroupsBoarded = ApiRoutes.Metric.MetricGroupsBoarded
  metricRegionsByGroups = ApiRoutes.Metric.MetricRegionsByGroups
  metricPracticesByRegions = ApiRoutes.Metric.MetricPracticesByRegions
  metricPracticesByGroups = ApiRoutes.Metric.MetricPracticesByGroups
  opportunityDelete = ApiRoutes.Metric.Oppprtunity.OpportunityDelete
  assignedBucketsToGroup = ApiRoutes.Metric.AssignedBucketsToGroup

  // Metric Goals

  metricGoals = ApiRoutes.Metric.Goals.GoalsData
  metricGoalsRegions = ApiRoutes.Metric.Goals.GoalsRegions
  metricGoalsPractices = ApiRoutes.Metric.Goals.GoalsPractices
  metricGoalsAvailableYears = ApiRoutes.Metric.Goals.GoalsAvailableYears
  metricGoalsByBucket = ApiRoutes.Metric.Goals.MetricGoalsByBucket
  yearMetricGoals = ApiRoutes.Metric.Goals.YearMetricGoals
  monthMetricGoals = ApiRoutes.Metric.Goals.MonthMetricGoals
  setMetricGoals = ApiRoutes.Metric.Goals.SetMetricGoals

  // Metric Opportunity

  allOpportunityMetrics = ApiRoutes.Metric.Opportunity.AllOpportunityMetrics
  metricOpportunityByBucket =
    ApiRoutes.Metric.Opportunity.MetricOpportunityByBucket
  metricGroupData = ApiRoutes.Metric.Opportunity.MetricGroupData
  metricRegionData = ApiRoutes.Metric.Opportunity.MetricRegionData
  metricPracticeData = ApiRoutes.Metric.Opportunity.MetricPracticeData
  metricOpportunityByMetric =
    ApiRoutes.Metric.Opportunity.MetricOpportunityByMetric
  metricStoreByMetric = ApiRoutes.Metric.Opportunity.MetricStoreByMetric
  metricStoreById = ApiRoutes.Metric.Opportunity.MetricStoreById
  setOpportunity = ApiRoutes.Metric.OpportunitySetData
  opportunity = ApiRoutes.Metric.Opportunity.Opportunity

  // Opportunity Dashboard
  opportunityDashboard = ApiRoutes.Metric.Oppprtunity.OpportunityDashboard
  advisor = ApiRoutes.Metric.Oppprtunity.Advisor
  advisorsByGroup = ApiRoutes.Metric.Oppprtunity.AdvisorsByGroup
  groupsByAdvisor = ApiRoutes.Metric.Oppprtunity.GroupsByAdvisor
  opportunityStatus = ApiRoutes.Metric.Oppprtunity.OpportunityStatus
  opportunityMoreColumns = ApiRoutes.Metric.Oppprtunity.OpportunityMoreColumns
  opportunityLogs = ApiRoutes.Metric.Oppprtunity.OpportunityLogs
  opportunityEditGoals = ApiRoutes.Metric.Oppprtunity.OpportunityEditGoals
  opportunityAvailableYear =
    ApiRoutes.Metric.Oppprtunity.OpportunityAvailableYear
  opportunityUpdateStatus = ApiRoutes.Metric.Oppprtunity.OpportunityUpdateStatus
  opportunityViewHistorical =
    ApiRoutes.Metric.Oppprtunity.OpportunityViewHistorical
  opportunityAdvisorGroups = ApiRoutes.Metric.Oppprtunity.AdvisorGroups
  opportunityDashboardByRole =
    ApiRoutes.Metric.Oppprtunity.OpportunityDashboardByRole

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use(this._handleRequest)
  }

  _handleRequest = async (axiosConfig: any) => {
    return axiosConfig
  }

  // Metric Blueprint

  getMetricTabs = (token: string) => {
    return this.instance({
      method: this.metricTabs.Method,
      url: this.metricTabs.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  getMetricGroups = (token: string) => {
    return this.instance({
      method: this.metricGroups.Method,
      url: this.metricGroups.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  getMetricGroupsBoarded = (token: string) => {
    return this.instance({
      method: this.metricGroupsBoarded.Method,
      url: this.metricGroupsBoarded.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }
  getMetricRegionsByGroups = (token: string, groups: any) => {
    return this.instance({
      method: this.metricRegionsByGroups.Method,
      url: this.metricRegionsByGroups.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: { group_list: groups },
    })
  }
  getMetricPracticesByRegions = (token: string, groups: any, regions: any) => {
    return this.instance({
      method: this.metricPracticesByRegions.Method,
      url: this.metricPracticesByRegions.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_list: groups,
        region_list: regions,
      },
    })
  }

  getMetricPracticesByGroups = (token: string, groups: any) => {
    return this.instance({
      method: this.metricPracticesByGroups.Method,
      url: this.metricPracticesByGroups.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        group_list: groups,
        region_list: [],
      },
    })
  }

  getAssignedBucketsToGroup = (token: string, groupSK: any) => {
    return this.instance({
      method: this.assignedBucketsToGroup.Method,
      url: this.assignedBucketsToGroup.EndPoint(groupSK),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  // Metric Goals APIs

  getMetricGoalsData = (token: string, groupSK: any, year: any) => {
    return this.instance({
      method: this.metricGoals.Method,
      url: this.metricGoals.EndPoint(groupSK, year),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getAllRegionsInAGroup = (token: string, groupSK: any) => {
    return this.instance({
      method: this.metricGoalsRegions.Method,
      url: this.metricGoalsRegions.EndPoint(groupSK),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getAllPracticesInARegion = (token: string, groupSK: any, region: any) => {
    return this.instance({
      method: this.metricGoalsPractices.Method,
      url: this.metricGoalsPractices.EndPoint(groupSK, region),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getAllAvailableYears = (token: string, groupSK: any) => {
    return this.instance({
      method: this.metricGoalsAvailableYears.Method,
      url: this.metricGoalsAvailableYears.EndPoint(groupSK),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getGoalsByBucket = (
    token: string,
    groupSK: any,
    metricBucketId: any,
    year: any,
  ) => {
    return this.instance({
      method: this.metricGoalsByBucket.Method,
      url: this.metricGoalsByBucket.EndPoint(groupSK, metricBucketId, year),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  setYearGoals = (token: string, data: any) => {
    return this.instance({
      method: this.yearMetricGoals.Method,
      url: this.yearMetricGoals.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    })
  }

  setMonthGoals = (token: string, data: any) => {
    return this.instance({
      method: this.monthMetricGoals.Method,
      url: this.monthMetricGoals.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    })
  }

  setGoals = (token: string, data: any) => {
    return this.instance({
      method: this.setMetricGoals.Method,
      url: this.setMetricGoals.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    })
  }

  // Metric Opportunity

  getAllOpportunityMetrics = (token: string, groupSK: any) => {
    return this.instance({
      method: this.allOpportunityMetrics.Method,
      url: this.allOpportunityMetrics.EndPoint(groupSK),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getOpportunityByBucket = (
    token: string,
    groupSK: any,
    metricBucketId: any,
  ) => {
    return this.instance({
      method: this.metricOpportunityByBucket.Method,
      url: this.metricOpportunityByBucket.EndPoint(groupSK, metricBucketId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getMetricGroupData = (token: string, groupSK: any, metricBucketId: any) => {
    return this.instance({
      method: this.metricGroupData.Method,
      url: this.metricGroupData.EndPoint(groupSK, metricBucketId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getMetricRegionData = (token: string, groupSK: any, metricId: any, region: any) => {
    return this.instance({
      method: this.metricRegionData.Method,
      url: this.metricRegionData.EndPoint(groupSK, metricId, region),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getMetricPracticeData = (
    token: string,
    groupSK: any,
    metricId: any,
    region: any,
  ) => {
    return this.instance({
      method: this.metricPracticeData.Method,
      url: this.metricPracticeData.EndPoint(groupSK, metricId, region),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getOpportunityByMetric = (token: string, groupSK: any, metricId: any) => {
    return this.instance({
      method: this.metricOpportunityByMetric.Method,
      url: this.metricOpportunityByMetric.EndPoint(groupSK, metricId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getStoreByMetric = (token: string, groupSK: any, metricId: any) => {
    return this.instance({
      method: this.metricStoreByMetric.Method,
      url: this.metricStoreByMetric.EndPoint(groupSK, metricId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getStoreById = (token: string, metricStoreId: any) => {
    return this.instance({
      method: this.metricStoreById.Method,
      url: this.metricStoreById.EndPoint(metricStoreId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  setOpportunityData = (token: string, data: any) => {
    return this.instance({
      method: this.setOpportunity.Method,
      url: this.setOpportunity.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: data,
    })
  }

  getOpportunity = (token: string, opportunityId: any) => {
    return this.instance({
      method: this.opportunity.Method,
      url: this.opportunity.EndPoint(opportunityId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  // Opportunity Dashboard

  getOpportunityDashboard = (
    token: string,
    creator_id: any,
    groupSK: any,
    region: any,
    practice: any,
    status: any,
    page?: number,
    limit?: number,
  ) => {
    return this.instance({
      method: this.opportunityDashboard.Method,
      url: this.opportunityDashboard.EndPoint(
        creator_id,
        groupSK,
        region,
        practice,
        status,
        page,
        limit,
      ),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getOpportunityDashboardByRole = (
    token: string,
    groupSK: any,
    region: any,
    practice: any,
    status: any,
  ) => {
    return this.instance({
      method: this.opportunityDashboardByRole.Method,
      url: this.opportunityDashboardByRole.EndPoint(
        groupSK,
        region,
        practice,
        status,
      ),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getAdvisor = (token: string) => {
    return this.instance({
      method: this.advisor.Method,
      url: this.advisor.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  getAdvisorsByGroup = (token: string, groupSk: any) => {
    return this.instance({
      method: this.advisorsByGroup.Method,
      url: this.advisorsByGroup.EndPoint(groupSk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  getGroupsByAdvisor = (token: string, advisorId: any) => {
    return this.instance({
      method: this.groupsByAdvisor.Method,
      url: this.groupsByAdvisor.EndPoint(advisorId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  getOpportunityStatus = (token: string) => {
    return this.instance({
      method: this.opportunityStatus.Method,
      url: this.opportunityStatus.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: undefined,
    })
  }

  deleteOpportunity = (token: string, opportunityId: any) => {
    return this.instance({
      method: this.opportunityDelete.Method,
      url: this.opportunityDelete.EndPoint(opportunityId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
  getOpportunityMoreColumns = (token: string, opportunityId: any) => {
    return this.instance({
      method: this.opportunityMoreColumns.Method,
      url: this.opportunityMoreColumns.EndPoint(opportunityId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getOpportunityLogs = (token: string, opportunityId: any) => {
    return this.instance({
      method: this.opportunityLogs.Method,
      url: this.opportunityLogs.EndPoint(opportunityId),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getOpportunityEditGoals = (
    token: string,
    practiceSk: any,
    metricId: any,
    year: any,
  ) => {
    return this.instance({
      method: this.opportunityEditGoals.Method,
      url: this.opportunityEditGoals.EndPoint(practiceSk, metricId, year),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getOpportunityAvailableYears = (token: string, groupSk: any) => {
    return this.instance({
      method: this.opportunityAvailableYear.Method,
      url: this.opportunityAvailableYear.EndPoint(groupSk),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getOpportunityUpdateStatus = (token: string, data: any) => {
    return this.instance({
      method: this.opportunityUpdateStatus.Method,
      url: this.opportunityUpdateStatus.EndPoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        id: data?.id,
        opportunity_status: data?.status,
      },
    })
  }

  getOpportunityViewHistorical = (token: string, id: any) => {
    return this.instance({
      method: this.opportunityViewHistorical.Method,
      url: this.opportunityViewHistorical.EndPoint(id),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }

  getGroupsByAdvisorId = (token: string, id: any) => {
    return this.instance({
      method: this.opportunityAdvisorGroups.Method,
      url: this.opportunityAdvisorGroups.EndPoint(id),
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {},
    })
  }
}
